type EventProps = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    plausible?: (eventName: string, options?: { props?: Record<string, string | number | boolean> }) => void;
  }
}

function toPlausibleProps(props?: EventProps): Record<string, string | number | boolean> | undefined {
  if (!props) return undefined;
  const out: Record<string, string | number | boolean> = {};
  for (const [k, v] of Object.entries(props)) {
    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') out[k] = v;
  }
  return Object.keys(out).length ? out : undefined;
}

export function trackEvent(name: string, props?: EventProps) {
  if (typeof window === 'undefined') return;
  window.gtag?.('event', name, props ?? {});
  const p = toPlausibleProps(props);
  window.plausible?.(name, p ? { props: p } : undefined);
}

